var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M56.333,2h-48c-4.611,0-8,3.52-8,8.13V41c0,4.611,3.737,8.087,8.348,8h30.543\n            l17.109,11V49c4.611,0.087,8-3.389,8-8V10.13C64.333,5.52,60.944,2,56.333,2z"}))));
}

Icon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"24px","height":"24px","viewBox":"0 0 64 64","enableBackground":"new 0 0 64 64","xmlSpace":"preserve"};

module.exports = Icon;

Icon.default = Icon;
